import React from 'react';
import { Typography, Box, IconButton, Stack, TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

// Shared presentation only. The live container supplies its existing handlers;
// onboarding supplies example data and inert/no-op handlers. No data hooks here.
export default function ConsultationTitleBar({ canEditTitle, currentConsultation, exportItem, handleDownloadReport, handleSaveConsultationTitle, isPopupReport, isTitleEditing, selectedReport, setIsTitleEditing, setTitleEditValue, titleBarTitle, titleEditValue }) {
  return (<Box sx={{ backgroundColor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '12px', px: 2, py: 1.25, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    {/* Left: title (or edit field) */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: 1, minWidth: 0 }}>
                      {isTitleEditing ? (
                        <>
                          <TextField
                            size="small"
                            autoFocus
                            value={titleEditValue}
                            onChange={(e) => setTitleEditValue(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') handleSaveConsultationTitle();
                              if (e.key === 'Escape') setIsTitleEditing(false);
                            }}
                            sx={{ flex: 1, maxWidth: 400, '& .MuiInputBase-input': { fontSize: '0.875rem', fontWeight: 600, py: 0.75 } }}
                          />
                          <Tooltip title="Save">
                            <IconButton size="small" onClick={handleSaveConsultationTitle} sx={{ color: '#29C0BB' }}>
                              <CheckIcon sx={{ fontSize: 17 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Cancel">
                            <IconButton size="small" onClick={() => setIsTitleEditing(false)} sx={{ color: '#6B7280' }}>
                              <CloseIcon sx={{ fontSize: 17 }} />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <Typography variant="body2" sx={{ fontWeight: 700, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {titleBarTitle}
                        </Typography>
                      )}
                    </Box>

                    {/* Right: Export + Edit */}
                    <Stack direction="row" spacing={0.5} alignItems="center" flexShrink={0}>
                      <Tooltip title={exportItem ? 'Export Document' : 'No report to export yet'}>
                        <span>
                          <IconButton
                            size="small"
                            disabled={!exportItem}
                            onClick={() => handleDownloadReport(exportItem)}
                            sx={{ color: '#6B7280', '&:hover': { color: '#111827', backgroundColor: '#F3F4F6' }, '&.Mui-disabled': { color: '#D1D5DB' } }}
                          >
                            <FileDownloadIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title={canEditTitle ? (isPopupReport ? 'Edit report title' : 'Edit consultation title') : 'No item to edit'}>
                        <span>
                          <IconButton
                            size="small"
                            disabled={!canEditTitle}
                            onClick={() => {
                              setIsTitleEditing(true);
                              setTitleEditValue(
                                isPopupReport
                                  ? (selectedReport?.title || '')
                                  : (currentConsultation?.chiefComplaint || '')
                              );
                            }}
                            sx={{ color: '#6B7280', '&:hover': { color: '#111827', backgroundColor: '#F3F4F6' }, '&.Mui-disabled': { color: '#D1D5DB' } }}
                          >
                            <EditIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </Stack>
                  </Box>);
}
